// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2y-1";
export var rateTableServiceLevelDropdown = "_2y-3";
export var rateTableTypeDropdown = "_2y-0";
export var rateTableValueModeDropdown = "_2y-2";